import moment from 'moment-timezone'
import { getDateFormat } from 'utils/authService'
import { SUBSCRIPTION_PLANS } from '../../constants'
import s from './SubscriptionInfo.scss'

const SubscriptionInfo = ({ users, freeTrial, subscriptionInfo }) => {
  return (
    <div className={s.infoContainer}>
      <h4>
        Your company was registered on:{' '}
        {moment(subscriptionInfo.startDate).format(`${getDateFormat()}`)}
      </h4>
      <h4>Current number of active users: {users.length}</h4>
      <h4>
        Current plan: {freeTrial ? 'Free Trial' : SUBSCRIPTION_PLANS[subscriptionInfo.plan]?.name}
      </h4>
      {freeTrial ? (
        <div className={s.planDescription}>
          <p>
            Your Free Trial started on{' '}
            {moment(subscriptionInfo.trialStartDate).format(`${getDateFormat()}`)} and will end on{' '}
            {moment(subscriptionInfo.trialEndDate).format(`${getDateFormat()}`)}.
          </p>
          <p>
            During the Free Trial, you can add as many users as you wish to experience all the
            functionality that iDealCRM offers.
          </p>
          <p>
            At the end of the Free Trial, we will count the number of active users in your account
            and apply a subscription plan accordingly.
          </p>
          <ul>
            <li>
              If you only have 1 active user, the Free 1-User Company subscription plan will be
              applied and no credit card will be required.
            </li>
            <li>
              If you have 2-10 users, the Small Company subscription will be applied and a credit
              card will be required at that time. It will not be charged until the end of the
              billing cycle.
            </li>
            <li>
              If you have 11+ users, the Enterprise subscription plan will be applied to your
              account and a credit card will be required at that time. It will not be charged until
              the end of the billing cycle.
            </li>
          </ul>
        </div>
      ) : (
        <div className={s.planDescription}>
          {subscriptionInfo.plan === 'FREE' && (
            <p>
              Your current plan doesn&apos;t require a credit card to be held on file. Please note
              that if you&apos;d like to add another user, you will be prompted to upgrade your plan
              to Small Company.
            </p>
          )}
          {subscriptionInfo.plan === 'SMALL_COMPANY' && (
            <>
              <p>
                Your current plan is Small Company and allows up to 10 active users in your account.
                Please note that if you&apos;d like to have more than 10 active users, you will be
                prompted to upgrade your plan to Enterprise.
              </p>
              <p>
                The credit card on file is charged at the end of each billing cycle. During this
                time, usage will be calculated and shown here for each user at a $35/user/month
                rate.
              </p>
            </>
          )}
          {subscriptionInfo.plan === 'ENTERPRISE' && (
            <>
              <p>
                Your current plan is Enterprise and accounts for 11+ active users in your account.
              </p>
              <p>
                The credit card on file is charged at the end of each billing cycle. During this
                time, usage will be calculated and shown here for each user at a $30/user/month
                rate.
              </p>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default SubscriptionInfo
